import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export const useUspItems = () => {
	const { t } = useI18n();

	const uspItems = computed(() => [
		{
			icon: 'user-graduate',
			text: t('aside.checkList.1'),
		},
		{
			icon: 'gamepad',
			text: t('aside.checkList.2'),
		},
		{
			icon: 'comments',
			text: t('aside.checkList.3'),
		},
		{
			icon: 'earth-america',
			text: t('aside.checkList.4'),
		},
		{
			icon: 'award',
			text: t('aside.checkList.5'),
		},
	]);

	return {
		uspItems,
	};
};
